//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
    root: {
        "& .MuiTextField-root": {
            margin: theme.spacing(1),
        },
        padding: 16,
    },
    mainDiv: {
        marginBottom: 100,
    },
    createLA: {
        fontWeight: "bold",
        fontSize: 20,
        padding: 15,
    },
    backBtnGrid: {
        marginTop: 16,
    },
    submitBtnGrid: {
        marginTop: 16,
        textAlign: "right",
    },
    btn: {
        textTransform: "capitalize",
        fontSize: "0.875rem",
        fontWeight: "bold",
    },
    toastCss: {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
    },
    dialogContent: {
        width: 400,
        "@media (max-width: 600px)": {
            width: 280,
        },
    },
    disalogContentText: {
        color: "green",
        textAlign: "center"
    },
    dialogText: {
        color: "#000",
        fontSize: 18,
    },
    dialogTextHead: {
        fontWeight: "bold",
    },
    closeBtn: {
        textTransform: "capitalize",
        fontSize: 18,
        fontWeight: "bold",
        backgroundColor: "#3f51b5",
        color: "#fff",
        "&:hover": {
            backgroundColor: "#3f51b5",
        },
    },
    dateInput: {
        width: "100%",
    },
    paymentdropenroll:{
        width:"250px",
        
      }
}));

export const UserConfirmationStyles = makeStyles((theme) => ({
    contentGrid: {
        textAlign: "center",
        fontSize: 16,
    },
    backBtn: {
        color: "#fff",
        backgroundColor: "#305698 !important",
        fontSize: 15,
        border: " 1px solid #2F7CBD",
        borderRadius: 10,
        textTransform: "capitalize",
        "&:hover": {
            backgroundColor: "#305698 !important",
        },
    },
    content1: {
        fontSize: "1.375rem",
        fontWeight: "bold",
        marginBottom: "10px",
        textAlign: "center",
    },
    content2: {
        width: "90%",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: 30,
    },
    content3: {
        display: "flex",
        justifyContent: "space-around",
    },
    content3Main: {
        width: "25%",
        background: "#ededed",
        padding: "10px",
        margin: "0 0 20px 0",
        border: "1px solid #707070",
        borderRadius: 15,
        alignItems: "center",
        boxShadow: "#999999 0px 0.5px 4px 0px inset, #999999 0.5px 0px 1px 0px, #ffffff 0px -6px 0px 0px inset, #999999 -0.5px 0px 0px 0px",

    },
    content3Span: {
        fontWeight: "bold",
    },
    content4:{
        fontSize: "1.125rem",
        fontWeight: "bold",
        marginBottom: "10px",
        textAlign: "center",
    },
    table: {
        marginTop: 100,
    },
    
}))